import {metadaApi} from '@dms/api/base';

import {
  type MonthlyStockTakeDetailResponse,
  MonthlyStockTakeDetailResponseSchema,
} from './MonthlyStockTakeDetailResponseSchema';

const monthlyStockTakeEndpoints = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getMonthlyStockTakeById: build.query<MonthlyStockTakeDetailResponse, string>({
      // The report module mounts at report/v1, while the operation starts with v1/report.
      query: (id) => ({
        url: `/report/v1/v1/report/monthly-stock-take/${encodeURIComponent(id)}`,
      }),
      extraOptions: {responseSchema: MonthlyStockTakeDetailResponseSchema},
    }),
  }),
});

export const useGetMonthlyStockTakeByIdQuery =
  monthlyStockTakeEndpoints.useGetMonthlyStockTakeByIdQuery;
